import React from 'react';
import { Link } from 'react-router-dom';
import SeoHead from '../components/SeoHead';
import { useAuth } from '../context/AuthContext';
import './AccountDeletionPage.css';

export default function AccountDeletionPage() {
  const { user } = useAuth();

  const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL?.trim() || 'support@letterquest.example';
  const subject = encodeURIComponent('Account deletion request');
  const body = encodeURIComponent(
    [
      'Please delete my Letter Quest account and associated data.',
      '',
      'If you are emailing from a different address than your account email, include the account email here:',
      'Account email: ',
      '',
      'Optional: Any additional details',
    ].join('\n')
  );

  return (
    <main className="account-deletion-page">
      <SeoHead
        title="Account deletion"
        description="How to delete your Letter Quest account and associated data."
        path="/account-deletion"
      />

      <h1>Account deletion</h1>
      <p className="account-deletion-page__lead">
        You can delete your account and associated gameplay data. Public leaderboards will no longer show your name after
        deletion.
      </p>

      {user ? (
        <div className="account-deletion-page__box">
          <h2>Signed in</h2>
          <p>
            You’re signed in. To permanently delete your account, go to <Link to="/account">Account</Link> and use the
            “Delete account” option.
          </p>
        </div>
      ) : (
        <div className="account-deletion-page__box">
          <h2>Not signed in</h2>
          <p>
            If you can still sign in, the fastest option is to <Link to="/login">sign in</Link> and delete your account
            from the <Link to="/account">Account</Link> page.
          </p>
        </div>
      )}

      <div className="account-deletion-page__box">
        <h2>Request deletion by email</h2>
        <p>
          If you can’t access your account, you can request deletion by email. Please contact{' '}
          <a href={`mailto:${supportEmail}?subject=${subject}&body=${body}`}>{supportEmail}</a>.
        </p>
        <p className="account-deletion-page__fineprint">
          We may ask for additional information to verify ownership before deleting account data.
        </p>
      </div>

      <p className="account-deletion-page__links">
        See also <Link to="/privacy">Privacy</Link> and <Link to="/terms">Terms</Link>.
      </p>
    </main>
  );
}

